import { jsx } from "react/jsx-runtime";
import { Box } from "@zillow/constellation-10";
import { omitUndefined } from "../../utils/lodash.esm.js";
import { LOAN_PROGRAMS } from "../../utils/zhl-calculator.esm.js";
import { RFC_2822_MONTHS } from "../AmortizationCalculator/AmortizationCalculator.utils.esm.js";
import CalculatorForm from "../CalculatorForm/CalculatorForm.esm.js";
import { FieldConfig } from "./LoanComparison.utils.esm.js";
import LoanComparisonFields from "./LoanComparisonFields.esm.js";
const LoanComparisonCalculator = ({
  defaultValues,
  editorMode
}) => {
  const finalDefaultValues = {
    // Default values
    [FieldConfig.typeOneLoanAmount.name]: "300000",
    [FieldConfig.typeOneLoanTerm.name]: LOAN_PROGRAMS.fixed30Year,
    [FieldConfig.typeOneInterestRate.name]: "4.17",
    [FieldConfig.typeOneLoanStartMonth.name]: RFC_2822_MONTHS[(/* @__PURE__ */ new Date()).getMonth()],
    [FieldConfig.typeOneLoanStartYear.name]: (/* @__PURE__ */ new Date()).getFullYear(),
    [FieldConfig.typeTwoLoanAmount.name]: "300000",
    [FieldConfig.typeTwoLoanTerm.name]: LOAN_PROGRAMS.fixed30Year,
    [FieldConfig.typeTwoInterestRate.name]: "4.17",
    [FieldConfig.typeTwoLoanStartMonth.name]: RFC_2822_MONTHS[(/* @__PURE__ */ new Date()).getMonth()],
    [FieldConfig.typeTwoLoanStartYear.name]: (/* @__PURE__ */ new Date()).getFullYear(),
    [FieldConfig.typeThreeLoanAmount.name]: "300000",
    [FieldConfig.typeThreeLoanTerm.name]: LOAN_PROGRAMS.fixed30Year,
    [FieldConfig.typeThreeInterestRate.name]: "4.17",
    [FieldConfig.typeThreeLoanStartMonth.name]: RFC_2822_MONTHS[(/* @__PURE__ */ new Date()).getMonth()],
    [FieldConfig.typeThreeLoanStartYear.name]: (/* @__PURE__ */ new Date()).getFullYear(),
    // Custom default values
    ...omitUndefined(defaultValues)
  };
  return /* @__PURE__ */ jsx(CalculatorForm, { fieldStorageKey: "LoanComparisonCalculatorFields", defaultValues: finalDefaultValues, editorMode, children: /* @__PURE__ */ jsx(Box, { css: {
    display: "flex",
    flexDirection: "column"
  }, children: /* @__PURE__ */ jsx(LoanComparisonFields, {}) }) });
};
export {
  LoanComparisonCalculator as default
};
